import React from "react";
import Link from "next/link";
import Image from "next/image";

const SidebarLogo = ({ menuHover, zeroPadding = false }) => {
  return (
    <div
      className={` logo-segment flex justify-between items-center bg-white dark:bg-metaxseed-black z-[9] ${zeroPadding ? "p-0" : "p-6"}
      ${menuHover ? "logo-hovered" : ""}
      ${
        " border-none"
      }
      
      `}
    >
      <Link href="/">
        <div className="flex items-center space-x-4">
          <div className="logo-icon">
              <Image
                src="https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/branding%2Fmxs_games%2Fv1%2Fwhite%2Fpng%2Fmxs_icon_white.png?alt=media&token=8a7e36ba-954b-46b3-bcb2-559cec885bdf"
                height={411}
                width={370}
                alt="Logo Icon"
              />
          </div>

            <div>
              <Image
                src="https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/branding%2Fmxs_games%2Fv1%2Fwhite%2Fpng%2Fmxs_text_text.png?alt=media&token=5d1cd22e-0907-4594-a3cd-d5e8d520037f"
                alt="Logo Text"
                className="h-8 mt-1"
                width={1533}
                height={330}
              />
            </div>
        </div>
      </Link>
    </div>
  );
};

export default SidebarLogo;
